import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_TreatmentPlanConsent = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GENERAL_TreatmentPlanConsent' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DOB:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Reacord Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtReacord' name='txtReacord' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Treatment Plan Consent:</span>
                    I understand that Mental Health Services are provided by independently licensed counselors', and counselor trainees under supervision and that the independently licensed counselor will review treatment plans and sign appropriate forms for payment.  <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only w-200 d-inline' />  offers no guarantees or positive assurances regarding the outcomes of the therapeutic services.
                    <br />

                    I have received a copy of and understand the Notice of Privacy Practices, a written summary of the Federal laws and regulations regarding confidentiality of client records as required by 42 CFR Part 2. I understand that I have the right to discuss my concerns, complaints, or grievances with any staff member from the  <input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only w-100 d-inline' /> who is involved in my care.

                    <br />

                    I also have the right to file a grievance with the  <input type='text' id='txtProviderName_4' name='txtProviderName_4' className='add-only w-100 d-inline' />  or as indicated in the Client Rights information that I have received.

                </p>

                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Treatment Provided:</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbTreatmentProvided_1' name='rbTreatmentProvided_1' className='add-only' value='' />  Assessment   </td>
                        <td className='w-250'> <input type='checkbox' id='rbTreatmentProvided_2' name='rbTreatmentProvided_2' className='add-only' value='' />  Treatment Plan   </td>
                        <td className='w-250'> <input type='checkbox' id='rbTreatmentProvided_3' name='rbTreatmentProvided_3' className='add-only' value='' />  Mental Health Counseling   </td>
                    </tr>
                    <tr>

                        <td className='w-250'> <input type='checkbox' id='rbTreatmentProvided_4' name='rbTreatmentProvided_4' className='add-only' value='' />  CPST   </td>
                        <td className='w-250'> <input type='checkbox' id='rbTreatmentProvided_5' name='rbTreatmentProvided_5' className='add-only' value='' />  TBS/PSR   </td>
                        <td className='w-250'> <input type='checkbox' id='rbTreatmentProvided_6' name='rbTreatmentProvided_6' className='add-only' value='' />  Group Counseling   </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Potential benefits and risks have been explained to me. I hereby give my consent to  <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only w-200 d-inline' />  for the above checked services, as applicable.
                </p>


                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client/Legal Guardian</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Clinician Signature</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Supervisor Signature</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
            </div>
        </form>

    )
}